import "../assets/index-542cf50a.css";
import { A as n } from "../chunks/actionGlobal-8c1c28c9.mjs";
import { G as s } from "../chunks/GenRandomId-cb9ccebe.mjs";
import { n as r } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const o = {
  name: "NcActionRadio",
  mixins: [n],
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: !1
    }
  },
  props: {
    /**
     * id attribute of the radio element
     */
    id: {
      type: String,
      default: () => "action-" + s(),
      validator: (t) => t.trim() !== ""
    },
    /**
     * checked state of the the radio element
     */
    checked: {
      type: Boolean,
      default: !1
    },
    /**
     * Define if this radio is part of a set.
     * Checking the radio will disable all the
     * others with the same name.
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * value of the radio input
     */
    value: {
      type: [String, Number],
      default: ""
    },
    /**
     * disabled state of the radio element
     */
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:checked",
    "change"
  ],
  computed: {
    /**
     * determines if the action is focusable
     *
     * @return {boolean} is the action focusable ?
     */
    isFocusable() {
      return !this.disabled;
    },
    /**
     * aria-checked attribute for role="menuitemcheckbox"
     *
     * @return {'true'|'false'|undefined} aria-checked value if needed
     */
    ariaChecked() {
      if (this.isInSemanticMenu)
        return this.checked ? "true" : "false";
    }
  },
  methods: {
    toggleInput(t) {
      this.$refs.label.click();
    },
    onChange(t) {
      this.$emit("update:checked", this.$refs.radio.checked), this.$emit("change", t);
    }
  }
};
var l = function() {
  var e = this, i = e._self._c;
  return i("li", { staticClass: "action", class: { "action--disabled": e.disabled }, attrs: { role: e.isInSemanticMenu && "presentation" } }, [i("span", { staticClass: "action-radio", attrs: { role: "menuitemradio", "aria-checked": e.ariaChecked } }, [i("input", { ref: "radio", staticClass: "radio action-radio__radio", class: { focusable: e.isFocusable }, attrs: { id: e.id, disabled: e.disabled, name: e.name, type: "radio" }, domProps: { checked: e.checked, value: e.value }, on: { keydown: function(a) {
    return !a.type.indexOf("key") && e._k(a.keyCode, "enter", 13, a.key, "Enter") || a.ctrlKey || a.shiftKey || a.altKey || a.metaKey ? null : (a.preventDefault(), e.toggleInput.apply(null, arguments));
  }, change: e.onChange } }), i("label", { ref: "label", staticClass: "action-radio__label", attrs: { for: e.id } }, [e._v(e._s(e.text))]), e._e()], 2)]);
}, c = [], d = /* @__PURE__ */ r(
  o,
  l,
  c,
  !1,
  null,
  "f482d6e9",
  null,
  null
);
const _ = d.exports;
export {
  _ as default
};
